module.exports = __webpack_public_path__ + "static/media/tela_login_sm.eb178b57.png";